"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
function getProfilePicUrl(participantId) {
    return config_1.default.profilePicAPI().endPoint() + participantId + ".jpg";
}
exports.getProfilePicUrl = getProfilePicUrl;
function updateProfilePic(participantId, request) {
    return rest_1.httpPost(config_1.default.profilePicAPI().endPoint() + ("edit/" + participantId), request);
}
exports.updateProfilePic = updateProfilePic;
